export module HeaderStyles {
    export let HeaderBackgroundColor = 'rgb(42,87,117)';

}